export const WatchoServicesCard = ({icon, title, desc}) => {
    return(
        <div className="watchoServicesCard">
            <div className="watchoServicesIcon">
                <img src={`../Images/WatchoDownloadLP/icons/${icon}`} />
            </div>
            <div className="watchoServicesDescription">
                <div className="watchoServicesTitle">
                    <h6>{title}</h6>
                </div>
                <div className="watchoServicesDescription">
                    {desc}
                </div>
            </div>
        </div>
    )
}